<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.3333 22L22 2L2 8.66667L11.2308 12.7692L15.3333 22ZM11.7484 10.8864L7.33332 8.92413L16.8992 5.73549L11.7484 10.8864ZM13.1136 12.2516L18.2645 7.10078L15.0759 16.6667L13.1136 12.2516Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script lang="ts">
import Vue, { PropType } from "vue"
export default Vue.extend({
  name: "MailedIcon",
  props: {
    color: String,
    size: { type: Number, default: 24 },
  },
  computed: {
    iconColor(): string | undefined {
      if (this.color === "primary") {
        return this.$vuetify.theme.themes.light.primary?.toString()
      }
      if (this.color === "textColor") {
        return this.$vuetify.theme.themes.light.textColor?.toString()
      }
      return (
        this.color || this.$vuetify.theme.themes.light.textColor?.toString()
      )
    },
  },
})
</script>
